import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import { get } from 'lodash'
import { connect } from 'react-redux'

import { MaterialModal } from 'components/layout'
import { Note, Title } from 'components/misc'
import { notification } from 'redux/modules/app'
import { modal } from 'helpers/decorators'
import style from './registration-info-modals.styl'
// import { createSelector } from 'reselect'
import { PAYMENT_TYPES } from 'constants/enums'
import config from 'config'

@connect(null, { push, notification })
@modal.trigger()
class RegistrationInfoModals extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    notification: PropTypes.func,
    modalObj: PropTypes.object,
    onClose: PropTypes.func,
    push: PropTypes.func,
    orgId: PropTypes.number
  }

  getData = key =>
    ({
      missingPayment: {
        title: 'Payment not completed',
        intlKey: 'label.payment_not_completed',
        action: 'Pay Now',
        actionIntlKey: 'button.pay_now',
        onClick: this.handleRedirect
      },
      missingParentalConsent: {
        title: 'Your registration is pending Guardian / Parent consent',
        intlKey: 'label.registration_pending_parental_consent',
        action: 'OK',
        actionIntlKey: 'button.ok',
        onClick: this.props.onClose
      }
    }[key])

  handleRedirect = () => {
    const authCode = get(this.props, 'modalObj.data.authCode')
    const paymentType = get(this.props, 'modalObj.data.paymentType')
    const orgId = get(this.props, 'orgId')

    authCode &&
    paymentType === PAYMENT_TYPES.online.id &&
    this.props.push(`${config.publicPath}/mpg-init/` + authCode)

    authCode &&
    paymentType === PAYMENT_TYPES.payPal.id &&
    this.props.push(`${config.publicPath}/paypal-init/` + authCode)

    authCode &&
    paymentType === PAYMENT_TYPES.globalPayments.id &&
    this.props.push(`${config.publicPath}/gp-init/` + orgId + '/' + authCode)

    authCode &&
    paymentType === PAYMENT_TYPES.globalPaymentsWebpay.id &&
    this.props.push(`${config.publicPath}/gp-wp-init/${authCode}`)

    !authCode &&
    this.props.notification(
      'Cannot fetch Online Payment Authorization Code from API',
      {
        status: 'error'
      }
    )
  }

  render() {
    const { modalId, modalObj } = this.props

    const missingParentalConsent =
      get(modalObj, 'data.missingParentalConsent') === true
    const texts = this.getData(
      missingParentalConsent ? 'missingParentalConsent' : 'missingPayment'
    )

    return (
      <MaterialModal.Body id={modalId} noHeader noClose noEscape narrow>
        <MaterialModal.Content minimal={missingParentalConsent}>
          <div className="text--center">
            <i className={`ico ico--warning ${style.ico}`} />
            <Title
              h2
              intlKey={texts.intlKey}
              style={{ paddingBottom: missingParentalConsent ? 50 : 0 }}
            >
              {texts.title}
            </Title>

            {!missingParentalConsent && (
              <Note intlKey="label.payment_not_successful_text">
                As you have not successfully completed the payment of the award
                you will shortly be redirected to the Payment Gateway to make
                payment
              </Note>
            )}

            {!missingParentalConsent && (
              <MaterialModal.Footer
                action={texts.action}
                actionKey={texts.actionIntlKey}
                insideContent
                onClick={texts.onClick}
              />
            )}
          </div>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}

export default RegistrationInfoModals
